$(document).ready(() => {
  const $exportButton = $('#export-button');
  if ($exportButton.length <= 0) { return; }

  const $exportContainer = $('#export-container');
  const $exportLoader = $('#exportLoader');

  $exportButton.on('click', () => {
    $exportLoader.removeClass('d-none');
  })

  App.cable.subscriptions.create(
    { channel: 'ExportChannel', profile_id: $exportButton.data('profile-id') }, {
      received(data) {
        if (data.status == 'success') {
          $exportLoader.addClass('d-none');
          $exportContainer.html(`<a href="${data.export_url}" class="text-dark fs-6">Export - ${data.created_at}</a>`)
          $exportContainer.removeClass('d-none');
          $exportContainer.find('a')[0].click();
        } else {
          $exportContainer.html('<p>Une erreur est survenue. Merci de réessayer ultérieurement.</p>');
          $exportLoader.addClass('d-none');
        }
      }
    }
  );
});
